var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tv-hls__video-container"},[_c('video',{ref:"video",staticClass:"video",attrs:{"autoplay":"","muted":"","playsinline":"","loop":"","controls":false},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }